import { Box, Typography } from '@mui/material';
import { Suspense, lazy } from 'react';

const PriceBookTable = lazy(() =>
  import('./price-book-table').then((module) => ({
    default: module.PriceBookTable,
  })),
);

const TabContentLoader = (): JSX.Element => (
  <Box
    display="flex"
    justifyContent="center"
    alignItems="center"
    minHeight="200px">
    <Typography>Loading...</Typography>
  </Box>
);

interface PriceBookProps {
  organizationId: string;
}

export const Pricebook = ({ organizationId }: PriceBookProps): JSX.Element => {
  if (!organizationId) {
    return <Box>No company selected</Box>;
  }

  return (
    <Box>
      <Suspense fallback={<TabContentLoader />}>
        <PriceBookTable organizationId={organizationId} />
      </Suspense>
    </Box>
  );
};
